import React, { Fragment, FC } from 'react';
import { Grid } from '@material-ui/core';
import { noop } from 'lodash';

import { PublicUserProfile } from 'api';
import { EmptyState, IEmptyState, LoadMoreButton, UserCard } from './';

interface IProps {
  profiles: PublicUserProfile[];
  emptyStateName?: keyof IEmptyState;
  loading?: boolean;
  disableLoadMore?: boolean;
  onLoadMore?: () => void;
}

const ProfileList: FC<IProps> = ({
  profiles,
  emptyStateName,
  loading,
  disableLoadMore,
  onLoadMore,
}) => {
  if (emptyStateName && !profiles.length) {
    return <EmptyState name={emptyStateName} />;
  }

  return (
    <Fragment>
      <Grid container spacing={2}>
        {profiles.map((profile: PublicUserProfile) => (
          <UserCard key={profile.id} user={profile} />
        ))}
      </Grid>
      {!disableLoadMore && <LoadMoreButton loading={loading} onClick={onLoadMore} />}
    </Fragment>
  );
};

ProfileList.defaultProps = {
  loading: false,
  disableLoadMore: false,
  onLoadMore: noop,
};

export default ProfileList;
